const SESSION_ID_PARAM = 'sessionId';

// Reads the anonymous sessionId from the URL and strips it, so the credential
// does not linger in browser history / Referer headers. Returns null when absent.
export function consumeSessionIdFromUrl(): string | null {
  if (typeof window === 'undefined') return null;

  const url = new URL(window.location.href);
  const sessionId = url.searchParams.get(SESSION_ID_PARAM);
  if (!sessionId) return null;

  url.searchParams.delete(SESSION_ID_PARAM);
  window.history.replaceState(window.history.state, '', url.toString());

  return sessionId;
}
